import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const imgUrl = (url, w = 800) => {
  if (!url) return "";
  if (url.includes("images.unsplash.com")) return `${url}?auto=format&fit=crop&w=${w}&q=72`;
  if (url.includes("images.pexels.com")) return `${url}?auto=compress&cs=tinysrgb&w=${w}`;
  return url;
};

// Responsive srcset builder for remote CDN images.
// Returns { srcSet, sizes } — pass to <img>.
export const imgSrcSet = (url, widths = [400, 800, 1200]) => {
  if (!url) return { srcSet: undefined, sizes: undefined };
  if (url.includes("images.unsplash.com") || url.includes("images.pexels.com")) {
    return {
      srcSet: widths.map((w) => `${imgUrl(url, w)} ${w}w`).join(", "),
      sizes: "(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw",
    };
  }
  // Local /products/<name>.jpg → try responsive webp
  const m = /^\/products\/([a-z0-9-]+)\.jpg$/i.exec(url);
  if (m) {
    const base = `/products/${m[1]}`;
    return {
      srcSet: widths.map((w) => `${base}-${w}.webp ${w}w`).join(", "),
      sizes: "(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw",
    };
  }
  return { srcSet: undefined, sizes: undefined };
};

// Return best local WebP src (for use as `src` attribute).
export const localWebp = (url, width = 800) => {
  const m = /^\/products\/([a-z0-9-]+)\.jpg$/i.exec(url || "");
  if (!m) return url;
  return `/products/${m[1]}-${width}.webp`;
};

export const money = (n) => `$${Number(n).toFixed(2)}`;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
